import React, { useState } from "react";
import FurnitureItem from "./furnitureItem";
import Chair from "./chair";
import "./style.css"
import "animate.css";

function Furniture({ furniture, chair, furnitureChairRef }) {
  const [showAll, setShowAll] = useState(false);
  const [showAllChairs, setShowAllChairs] = useState(false);
  const itemsToShow = showAll ? furniture : furniture.slice(0, 4);
  const itemsToShowChairs = showAllChairs ? chair : chair.slice(0, 4);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };
  const toggleShowAllChairs = () => {
    setShowAllChairs(!showAllChairs);
  };

  return (
    <div>
      <div className="grid-container animate__animated animate__fadeIn">
        <div>
          <h1 className="text-[46px] text-[#2a254b] max-lg:ml-4">
            Столдор
          </h1>
          <div className="grid">
            {itemsToShow.map((el) => (
              <FurnitureItem key={el.id} furniture={el} />
            ))}
          </div>
        </div>
        {!showAll ? (
          <div className="flex justify-center mt-4 mb-14">
            <button
              onClick={toggleShowAll}
              className="headerdown-button bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md text-[16px] py-[16px] px-[32px] text-center justify-center mt-10"
            >
              Бүт коллекцияңы көрүү
            </button>
          </div>
        ) : (
          <div>
            {" "}
            <div className="flex justify-center -mt-4">
              <button
                onClick={() => {
                  toggleShowAll();
                }}
                className="headerdown-button bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md text-[16px] py-[16px] px-[32px] text-center justify-center mt-10"
              >
                Коллекцияны жабуу
              </button>
            </div>
          </div>
        )}
        <div ref={furnitureChairRef}>
          <h1 className="text-[46px] text-[#2a254b] max-lg:ml-4">
            Стулдар
          </h1>
          <div className="grid">
          {itemsToShowChairs.map((el) => (
              <Chair key={el.id} chair={el} />
            ))}
          </div>
          {!showAllChairs ? (
            <div className="flex justify-center mt-4 mb-14">
              <button
                onClick={toggleShowAllChairs}
                className="headerdown-button bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md text-[16px] py-[16px] px-[32px] text-center justify-center mt-10"
              >
                Бүт коллекцияңы көрүү
              </button>
            </div>
          ) : (
            <div>
              {" "}
              <div className="flex justify-center -mt-4">
                <button
                  onClick={() => {
                    toggleShowAllChairs();
                  }}
                  className="headerdown-button bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md text-[16px] py-[16px] px-[32px] text-center justify-center mt-10"
                >
                  Коллекцияны жабуу
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Furniture;
